<template>
  <px-lateral-dialog content-class="rounded-card" v-model="dialog" width="800">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Recusar solicitação
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="required rounded-tag-small"
            label="Motivo da recusa"
            counter="1500"
            rows="4"
            v-model="motivoRecusa"
            :error="$v.motivoRecusa.$error"
            @blur="$v.motivoRecusa.$touch()"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer/>
      <v-btn text class="normal-btn-text" @click="close">
        Fechar
      </v-btn>
      <v-btn color="primary" class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loading" @click="onClickRecusar">
        Recusar
      </v-btn>
    </template>
  </px-lateral-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      dialog: false,
      motivoRecusa: null,
    };
  },
  methods: {
    onClickRecusar() {
      if (this.validateForm()) {
        return;
      }
      this.recusar();
    },
    recusar() {
      this.$emit('recusar', { motivoRecusa: this.motivoRecusa });
      this.close();
    },
    close() {
      this.dialog = false;
    },
  },
  validations: {
    motivoRecusa: {
      required,
    },
  },
};
</script>
